<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show"  :title="title"
		destroy-on-close :showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="钉钉编码">
					<el-input v-model="form.mkcode"></el-input>
				</el-form-item>
				<el-form-item label="审核人">
					<staff v-model="form.checkstaffid" @modalsubmit="staffsubmit"></staff>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return {}
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				if (this.row) {
					this.form.mkcode = this.row.mkcode
					this.form.checkstaffid = this.row.checkstaffid
					if (!this.form.mkcode) {
						this.form.checkstaffid = this.$store.state.system.user.id
					}
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.activeName = this.device == 'pc' ? 'track' : 0
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},
			showPhone() {
				this.activeName = 0
				this.handleClickPhone(this.activeName)
			},
			modalShow() {
				this.modal = true
			},
			staffsubmit(e) {
				this.form.checkstaffid = e.data
			},
			submit() {
				this.$api.reconciliationcurrent.setMkCode(this.row.id, this.form).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})

				//this.cancel()
			}
		},
		components: {
			staff
		}
	}
</script>